import { db, delay } from "./api";

export const productService = {
  async getProducts() {
    await delay(250);
    return [...db.products];
  },

  async getProductById(id) {
    await delay(150);
    return db.products.find((p) => p.id === id) || null;
  },

  async createProduct(productData) {
    await delay(300);
    const newProduct = {
      ...productData,
      id: `PROD-${String(db.products.length + 1).padStart(3, "0")}`,
      active: true
    };
    db.products.unshift(newProduct);
    db.persistAll();
    return newProduct;
  },

  async updateProduct(id, updates) {
    await delay(300);
    const index = db.products.findIndex((p) => p.id === id);
    if (index !== -1) {
      db.products[index] = { ...db.products[index], ...updates };
      db.persistAll();
      return db.products[index];
    }
    throw new Error("Product not found");
  },

  async deleteProduct(id) {
    await delay(250);
    db.products = db.products.filter((p) => p.id !== id);
    db.persistAll();
    return true;
  },

  async getBatches() {
    await delay(200);
    return [...db.batches];
  },

  async adjustStock(productId, warehouseId, binCode, physicalCount, systemCount, reason, approver) {
    await delay(400);
    const variance = physicalCount - systemCount;
    // Find or update batch in that bin
    const batch = db.batches.find((b) => b.productId === productId && b.binCode === binCode);
    if (batch) {
      batch.qtyRemaining = physicalCount;
    }
    // Record audit log
    const product = db.products.find((p) => p.id === productId);
    db.auditLogs.unshift({
      id: `AUD-${Date.now()}`,
      user: approver || "System Admin",
      role: "Admin",
      action: "Stock Adjustment",
      module: "Inventory",
      timestamp: new Date().toISOString().replace("T", " ").slice(0, 19),
      details: `Reconciled ${product?.name || productId} in ${binCode}. Variance: ${variance > 0 ? "+" : ""}${variance}. Reason: ${reason}`
    });
    db.persistAll();
    return { success: true, variance };
  }
};
